export class ProgressInfo {
  isVisible: boolean = false; //used at the component selector level in order to remove space from html
  stepName: string = "";
  nextStepName: string = "";
  totalSteps: number = 10;
  currentStep: number = 1;
}
